import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, Text } from '@common-fe/common-fe';

import { useMyMoneyStore } from '@/modules/UseMyMoney/stores';
import { UseMyMoneyOption } from '@/modules/UseMyMoney/UseMyMoney.types';

import BillDetails from './BillDetails';
import ClaimNotes from './ClaimNotes';

const ClaimSummaryOptionalFields: React.FC<BoxExtendedProps> = ({ ...props }) => {
  const { t } = useTranslation();
  const { useMyMoneyOption } = useMyMoneyStore();

  return (
    <Box data-testId="claim-summary-optional-fields" {...props}>
      <Text data-testId="claim-summary-optional-fields_title" weight={700}>
        {t('Optional')}
      </Text>

      <Box margin={{ top: 'spacing8' }}>
        <ClaimNotes />
      </Box>

      {useMyMoneyOption === UseMyMoneyOption.PAY_A_PROVIDER ? (
        <Box margin={{ top: 'spacing8' }}>
          <BillDetails />
        </Box>
      ) : null}
    </Box>
  );
};

export default ClaimSummaryOptionalFields;
